import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModalidadeService } from '../shared/services/modalidade.service';
import { ModalidadeFillerInterceptor } from './modalidade-filler-interceptor';
import { ProxyReversoErrorHandlerInterceptor } from './proxy-reverso-error-handler-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ProxyReversoErrorHandlerInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ModalidadeFillerInterceptor, multi: true, deps: [ModalidadeService] },
];

